import http, { typedHttp } from '../http';

import { adaptFeedbackResponse } from './adapter';
import {
  type CreateFeedbackRequest,
  type PresentationFeedbackResponse,
} from './aliases';
import { type FeedbackRole } from './types';

import {
  CREATE_FEEDBACK_ENDPOINT,
  USER_FEEDBACK_ENDPOINT,
} from '@/constants/endpoints';

type Args = {
  role: FeedbackRole;
  sellerId: number;
  offset?: string;
  limit?: number;
};

export async function fetchFeedback({
  sellerId,
  role,
  offset,
  limit = 24,
}: Args) {
  const response = await http.get<PresentationFeedbackResponse>(
    USER_FEEDBACK_ENDPOINT.replace(':userId', sellerId.toString()),
    {
      params: {
        role,
        offset,
        limit: limit.toString(),
      },
    }
  );

  return {
    ...response,
    data: adaptFeedbackResponse(response.data),
  };
}

export function createFeedback({
  text,
  rating,
  transaction_id,
}: CreateFeedbackRequest) {
  return typedHttp.post(
    CREATE_FEEDBACK_ENDPOINT,
    {
      text,
      rating,
      transaction_id,
    },
    {
      withAuth: true,
    }
  );
}
